<div class="relative z-50">
  <div class="flex gap-2 pr-3">
    @if (simulationService.recordingTime()) {
      <div
        class="bo-title flex size-14 items-center justify-center rounded-full border-none bg-bo-black/70 p-0 !text-bo-white backdrop-blur-lg"
      >
        {{ recordingTime() }}
      </div>
      <button
        type="button"
        class="z-50 flex size-14 cursor-pointer items-center justify-center rounded-full border-none bg-bo-primary p-0"
        [ngClass]="{ 'opacity-50': isScreenshot() }"
        (click)="takeScreenshot.emit()"
      >
        <svg-icon
          src="fa-icons/camera.svg"
          class="fill-bo-white"
          [svgStyle]="{ 'height.px': 28 }"
        />
      </button>
    }
    @if (messageService.messages().length > 0) {
      <button
        type="button"
        class="z-50 ml-3 flex size-14 cursor-pointer items-center justify-center rounded-full border-none bg-bo-blue/70 p-0 backdrop-blur-lg"
        [ngClass]="{ 'animate-shrink': addedMessageToHistory() }"
        (click)="
          messagesExpanded.set(!messagesExpanded());
          expandMessages.emit(messagesExpanded())
        "
      >
        <svg-icon
          [src]="
            messagesExpanded()
              ? 'fa-icons/chevron-up.svg'
              : 'fa-icons/messages.svg'
          "
          class="fill-bo-white"
          [svgStyle]="{ 'height.px': 24 }"
        />
      </button>
    }
  </div>
</div>
